import { useState } from "react";
import axios from "axios";
import { Send } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const initialState = {
  full_name: "",
  email: "",
  country: "",
  preferred_schedule: "",
  goals: "",
  message: "",
};

export const LeadForm = ({ formType = "inquiry", submitLabel = "Send Inquiry", formId = "lead-form" }) => {
  const [formData, setFormData] = useState(initialState);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (event) => {
    setFormData((previous) => ({
      ...previous,
      [event.target.name]: event.target.value,
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsSubmitting(true);

    try {
      await axios.post(`${API}/leads`, {
        ...formData,
        form_type: formType,
      });
      setFormData(initialState);
      toast.success("Thanks! We will contact you soon. मिलते हैं जल्द ही!", {
        description: "Your request has been received.",
      });
    } catch (error) {
      toast.error("Unable to submit right now", {
        description: "Please retry in a moment or message on WhatsApp.",
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4" data-testid={`${formId}-container`}>
      <Input
        name="full_name"
        value={formData.full_name}
        onChange={handleChange}
        placeholder="Full name"
        required
        className="h-12 rounded-xl border-border bg-white"
        data-testid={`${formId}-name-input`}
      />
      <Input
        type="email"
        name="email"
        value={formData.email}
        onChange={handleChange}
        placeholder="Email address"
        required
        className="h-12 rounded-xl border-border bg-white"
        data-testid={`${formId}-email-input`}
      />
      <Input
        name="country"
        value={formData.country}
        onChange={handleChange}
        placeholder="Current country"
        required
        className="h-12 rounded-xl border-border bg-white"
        data-testid={`${formId}-country-input`}
      />
      <Input
        name="preferred_schedule"
        value={formData.preferred_schedule}
        onChange={handleChange}
        placeholder="Preferred class timings"
        required
        className="h-12 rounded-xl border-border bg-white"
        data-testid={`${formId}-schedule-input`}
      />
      <Input
        name="goals"
        value={formData.goals}
        onChange={handleChange}
        placeholder="Main goal (e.g. daily conversation, travel, work)"
        required
        className="h-12 rounded-xl border-border bg-white"
        data-testid={`${formId}-goals-input`}
      />
      <Textarea
        name="message"
        value={formData.message}
        onChange={handleChange}
        placeholder="Anything else you'd like me to know?"
        className="min-h-[110px] rounded-xl border-border bg-white"
        data-testid={`${formId}-message-input`}
      />
      <Button
        type="submit"
        disabled={isSubmitting}
        className="h-12 w-full rounded-full bg-accent text-accent-foreground transition-transform duration-300 hover:scale-[1.02]"
        data-testid={`${formId}-submit-button`}
      >
        <Send className="h-4 w-4" />
        {isSubmitting ? "Submitting..." : submitLabel}
      </Button>
    </form>
  );
};